<template>
  <div class="list-settings">

		<div v-if="typeSystem === 1">
			<div class="list-settings_item"
					 v-for="(settingsItem, indexSettingsItem) in settingsList"
					 v-bind:key="indexSettingsItem"
					 v-bind:class="{ 'list-settings_item__active' : activeSettingsItem === indexSettingsItem, 'list-settings_item__disabled' : !settingsItem.status }"
					 v-on:click="changeSettingsItem( indexSettingsItem )"
					 v-show="indexSettingsItem !== 3">
				<img :src="settingsItem.img" class="list-settings_icon">
				<img :src="settingsItem.imgActive" class="list-settings_icon list-settings_icon__active">
				{{ settingsItem.name }}
			</div>
		</div>
		<div v-else>
			<div class="list-settings_item"
					 v-for="(settingsItem, indexSettingsItem) in settingsListMobicar"
					 v-bind:key="settingsItem.id"
					 v-bind:class="{ 'list-settings_item__active' : activeSettingsItem === settingsItem.id, 'list-settings_item__disabled' : !settingsItem.status }"
					 v-on:click="changeSettingsItem( indexSettingsItem, settingsItem.id )">
				<img class="list-settings_icon">
				<img :src="settingsItem.img" class="list-settings_icon">
				<img :src="settingsItem.imgActive" class="list-settings_icon list-settings_icon__active">
				{{ settingsItem.name }}
			</div>
		</div>

    <div class="settings-save"
				 v-if="typeSystem === 1">
      <button class="btn btn-clean btn-brd"
							v-on:click="saveSettings()"
			        v-bind:disabled="!isOnline || saveBtnDisabled">Сохранить</button>
			<div v-if="!isOnline"
					 class="text-small text-color-accent text-left isOffLine"	>
				Вы не можете сохранять настройки когда автомобиль находится не в сети
			</div>
    </div>
  </div>
</template>

<script>
  export default {
    data : function () {
      return{
        settingsList: [
          {
            name : 'Автозапуск двигателя',
            img : require('../../assets/img/settings/s-autostart.svg'),
            imgActive : require('../../assets/img/settings/s-autostart_w.svg'),
            status : true
          },
          {
            name : 'Уведомления от охранной системы',
            img : require('../../assets/img/settings/s-message.svg'),
            imgActive : require('../../assets/img/settings/s-message_w.svg'),
            status : true,
            id : 5
          },
          {
            name : 'Общие настройки',
            img : require('../../assets/img/settings/s-settings.svg'),
            imgActive : require('../../assets/img/settings/s-settings_w.svg'),
            status : true
          },
          {
            name : 'Автомобиль на карте',
            img : require('../../assets/img/settings/s-geo.svg'),
            imgActive : require('../../assets/img/settings/s-geo_w.svg'),
            status : true
          },
          {
            name : 'Параметры охранной системы',
            img : require('../../assets/img/settings/s-protection.svg'),
            imgActive : require('../../assets/img/settings/s-protection_w.svg'),
            status : true
          },
          {
            name : 'Датчики',
            img : require('../../assets/img/settings/s-sensors.svg'),
            imgActive : require('../../assets/img/settings/s-sensors_w.svg'),
            status : true
          },
          {
            name : 'Общий доступ к автомобилю',
            img : require('../../assets/img/settings/s-share.svg'),
            imgActive : require('../../assets/img/settings/s-share_w.svg'),
            status : true,
            id : 7
          }
        ],
				settingsListMobicar : [
          {
            name : 'Mobicar 3 PRO',
            img : require('../../assets/img/mobicar/settings/logo-pril.svg'),
            imgActive : require('../../assets/img/mobicar/settings/logo-pril.svg'),
            status : true,
						id : 0
          },
          {
            name : 'Информация об устройстве',
            img : require('../../assets/img/settings/s-settings.svg'),
            imgActive : require('../../assets/img/settings/s-settings_w.svg'),
            status : true,
            id : 8
          },
					{
						name : 'Звуковые сигналы и световая сигнализация',
            img : require('../../assets/img/settings/s-settings.svg'),
            imgActive : require('../../assets/img/settings/s-settings_w.svg'),
						status : true,
            id : 1
					},
					{
						name : 'Параметры охранной системы',
            img : require('../../assets/img/settings/s-settings.svg'),
            imgActive : require('../../assets/img/settings/s-settings_w.svg'),
						status : true,
            id : 2
					},
					{
						name : 'Автозапуск',
            img : require('../../assets/img/settings/s-settings.svg'),
            imgActive : require('../../assets/img/settings/s-settings_w.svg'),
						status : true,
            id : 3
					},
					{
						name : 'Датчики удара и наклона',
            img : require('../../assets/img/settings/s-settings.svg'),
            imgActive : require('../../assets/img/settings/s-settings_w.svg'),
						status : true,
            id : 4
					},
					{
						name : 'Оповещения',
            img : require('../../assets/img/settings/s-settings.svg'),
            imgActive : require('../../assets/img/settings/s-settings_w.svg'),
						status : true,
            id : 5
					},
					{
						name : 'Опции PRO версии',
            img : require('../../assets/img/settings/s-settings.svg'),
            imgActive : require('../../assets/img/settings/s-settings_w.svg'),
						status : true,
            id : 6
					},
          {
            name : 'Общий доступ к автомобилю',
            img : require('../../assets/img/settings/s-share.svg'),
            imgActive : require('../../assets/img/settings/s-share_w.svg'),
            status : true,
            id : 7
          },
				],

				saveBtnDisabled : false
      }
    },
    mounted : function(){
      let list = this.settingsList;
      if( this.typeSystem !== 1 ){
        list = this.settingsListMobicar;

        if( this.typeSystem === 3 ){
          this.settingsListMobicar.splice(0, 1);
          this.$store.dispatch('settingPanel', 8);
        }
      }

      if( !this.$store.state.cars.list[this.currentIndex].access_notification ){
        for( let i = 0; i < list.length; i++ ){
          if( list[i].id === 5 ){
            list[i].status = false;
            break;
          }
        }
      }
      if( !this.$store.state.cars.list[this.currentIndex].access_share ){
        for( let i = 0; i < list.length; i++ ){
          if( list[i].id === 7 ){
            list[i].status = false;
            break;
          }
        }
      }
    },
    computed : {
      currentIndex : function () {
        return this.$store.state.cars.current.index
      },
      currentCar : function(){
        return this.$store.state.cars.current
      },
      activeSettingsItem : function () {
        return this.$store.state.panels.settings
      },
      typeSystem : function() {
        return this.$store.state.cars.list[this.$store.state.cars.current.index].device.type
			},
      lastCMD : function () {
        return this.$store.state.cars.lastSocket.cmd
      },
			isOnline : function () {
				return this.$store.state.cars.state[this.$store.state.cars.current.id].is_online
      }
    },
    methods : {
      changeSettingsItem : function (index, id) {
        let list = this.settingsList;
        let data = index;

        if( this.typeSystem !== 1 ){
          list = this.settingsListMobicar;
          data = id;
				}

        if( list[ index ].status ){
          this.$store.dispatch('settingPanel', data);
        }
      },
      saveSettings : function () {
        this.saveBtnDisabled = true;
        this.$store.dispatch('saveSettings');
      }
    },
		watch : {
      lastCMD : function ( newVal ) {
        if( newVal.car_id === this.currentCar.id ){
          // Сохранение настроек
          if( newVal.data.cmd === "update_settings" ){
            if( newVal.data.state === 'SUCCESS' ){
              this.saveBtnDisabled = false;
            }else if( newVal.data.state === 'ERROR' ){
              console.log( newVal.data );
            }
          }
        }
      }
		}
  }
</script>